export const TYPES = {
  LOGIN_LOADING: "login/LOGIN_LOADING",
  LOGIN_SUCCESS: "login/LOGIN_SUCCESS",
  LOGIN_FAILED: "login/LOGIN_FAILED",
  LOGOUT_SUCCESS: "login/LOGOUT_SUCCESS",
};
